export default {
  data() {
    return {
      history: [],
      historyIndex: -1,
      historyLimit: 50
    }
  },
  methods: {
    saveToHistory() {
      if (this.historyIndex < this.history.length - 1) {
        this.history = this.history.slice(0, this.historyIndex + 1)
      }
      const stateCopy = JSON.parse(JSON.stringify(this.placeholders))
      this.history.push(stateCopy)
      this.historyIndex = this.history.length - 1
      if (this.history.length > this.historyLimit) {
        this.history.shift()
        this.historyIndex--
      }
    },
    undo() {
      if (this.historyIndex <= 0) return
      this.historyIndex--
      const prevState = this.history[this.historyIndex]
      this.placeholders = JSON.parse(JSON.stringify(prevState))
    },
    redo() {
      if (this.historyIndex >= this.history.length - 1) return
      this.historyIndex++
      const nextState = this.history[this.historyIndex]
      this.placeholders = JSON.parse(JSON.stringify(nextState))
    },
    // Проверка фокуса ввода
    isInputFocused() {
      const tag = document.activeElement.tagName
      return tag === 'INPUT' || tag === 'TEXTAREA' || document.activeElement.isContentEditable
    },
    // Проверка модификатора (Ctrl для Windows/Linux, Cmd для macOS)
    isModifierKey(event) {
      return event.ctrlKey || event.metaKey
    },
    handleKeydown(event) {
      const isInput = this.isInputFocused()
      const isModifier = this.isModifierKey(event)

      // === Хоткеи, работающие даже в инпутах ===
      if (isModifier) {
        // Ctrl/Cmd + A (Select All) - работает везде
        if (event.code === 'KeyA') {
          // В инпуте - стандартное выделение текста
          // Не в инпуте - выделение всех плейсхолдеров
          if (!isInput) {
            event.preventDefault()
            if (this.selectAllPlaceholders) {
              this.selectAllPlaceholders()
            }
          }
          return
        }

        // Ctrl/Cmd + Z (Undo) - работает везде
        if (event.code === 'KeyZ' && !event.shiftKey) {
          event.preventDefault()
          this.undo()
          return
        }

        // Ctrl/Cmd + Y или Ctrl/Cmd + Shift + Z (Redo)
        if (event.code === 'KeyY' || (event.code === 'KeyZ' && event.shiftKey)) {
          event.preventDefault()
          this.redo()
          return
        }

        // ✅ Ctrl/Cmd + 0 (Reset Zoom)
        if (event.code === 'Digit0' || event.code === 'Numpad0') {
          event.preventDefault()
          if (this.resetZoom) {
            this.resetZoom()
          }
          return
        }

        // ✅ Ctrl/Cmd + + (Zoom In)
        if (event.code === 'Equal' || event.code === 'NumpadAdd') {
          event.preventDefault()
          if (this.zoomIn) {
            this.zoomIn()
          }
          return
        }

        // ✅ Ctrl/Cmd + - (Zoom Out)
        if (event.code === 'Minus' || event.code === 'NumpadSubtract') {
          event.preventDefault()
          if (this.zoomOut) {
            this.zoomOut()
          }
          return
        }
      }

      // === Хоткеи, НЕ работающие в инпутах ===
      if (isInput) {
        return
      }

      if (isModifier) {
        // Ctrl/Cmd + C (Copy)
        if (event.code === 'KeyC') {
          event.preventDefault()
          if (this.copySelected) this.copySelected()
          return
        }

        // Ctrl/Cmd + X (Cut)
        if (event.code === 'KeyX') {
          event.preventDefault()
          if (this.cutSelected) this.cutSelected()
          return
        }

        // Ctrl/Cmd + V (Paste)
        if (event.code === 'KeyV') {
          event.preventDefault()
          if (this.pasteElements) {
            this.pasteElements(null)
          }
          return
        }

        // Ctrl/Cmd + Стрелки (Move Placeholder)
        if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
          event.preventDefault()
          if (this.moveSelectedByKeyboard) {
            this.moveSelectedByKeyboard(event.code)
          }
        }
      } else {
        // Backspace / Delete (Delete Placeholder)
        if (event.code === 'Backspace' || event.code === 'Delete') {
          if (this.selectedPlaceholders && this.selectedPlaceholders.length > 0) {
            event.preventDefault()
            if (this.deleteSelectedFields) this.deleteSelectedFields()
            return
          }
        }

        // Стрелки (Scroll Document)
        if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
          event.preventDefault()
          if (this.scrollDocumentByKeyboard) {
            this.scrollDocumentByKeyboard(event.code)
          }
        }
      }
    },
    // Выделение всех плейсхолдеров
    selectAllPlaceholders() {
      this.selectedPlaceholders = this.placeholders.map(p => p.id)
      this.lastSelectionRect = null
    },
    // Вырезание (копировать + удалить)
    cutSelected() {
      if (!this.selectedPlaceholders || this.selectedPlaceholders.length === 0) {
        return
      }
      if (this.copySelected) {
        this.copySelected()
      }
      if (this.deleteSelectedFields) {
        this.deleteSelectedFields()
      }
    },
    // Перемещение стрелками
    moveSelectedByKeyboard(code) {
      if (!this.selectedPlaceholders || this.selectedPlaceholders.length === 0) {
        return
      }
      const step = 0.1
      let dx = 0
      let dy = 0
      if (code === 'ArrowUp') dy = -step
      if (code === 'ArrowDown') dy = step
      if (code === 'ArrowLeft') dx = -step
      if (code === 'ArrowRight') dx = step
      this.placeholders.forEach(p => {
        if (this.selectedPlaceholders.includes(p.id)) {
          p.x += dx
          p.y += dy
        }
      })
      this.saveToHistory()
    },
    // Скролл стрелками
    scrollDocumentByKeyboard(code) {
      const container = this.$refs.pdfContainer
      if (!container) return
      const step = 50
      if (code === 'ArrowUp') container.scrollTop -= step
      if (code === 'ArrowDown') container.scrollTop += step
      if (code === 'ArrowLeft') container.scrollLeft -= step
      if (code === 'ArrowRight') container.scrollLeft += step
    },
    // Удаление выбранных
    deleteSelectedFields() {
      if (this.selectedPlaceholders.length === 0) return
      this.placeholders = this.placeholders.filter(p => !this.selectedPlaceholders.includes(p.id))
      this.selectedPlaceholders = []
      this.saveToHistory()
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
  }
}
